import React,{useState,useContext, useEffect} from 'react'
const ChatConversationContext = React.createContext();

export const useChatConversationProvider = () => {
    return useContext(ChatConversationContext);
}

export const ChatConversationProvider = (props) =>{
    const [conversationList,setConversationList] = useState([]);
    const value= {
        conversationList,
        setConversationList,    
    }
    return (
        <ChatConversationContext.Provider value= {value}>
                {props.children}
        </ChatConversationContext.Provider>
    )
}